export default __webpack_public_path__ + "static/media/dropdownTrash.814b1346.svg";